/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadDiagnoses } from './LeadDiagnoses';
import {
    LeadDiagnosesFromJSON,
    LeadDiagnosesFromJSONTyped,
    LeadDiagnosesToJSON,
    LeadDiagnosesToJSONTyped,
} from './LeadDiagnoses';

/**
 * 
 * @export
 * @interface GetLeadDiagnoses200Response
 */
export interface GetLeadDiagnoses200Response {
    /**
     * 
     */
    data?: LeadDiagnoses;
}

/**
 * Check if a given object implements the GetLeadDiagnoses200Response interface.
 */
export function instanceOfGetLeadDiagnoses200Response(value: object): value is GetLeadDiagnoses200Response {
    return true;
}

export function GetLeadDiagnoses200ResponseFromJSON(json: any): GetLeadDiagnoses200Response {
    return GetLeadDiagnoses200ResponseFromJSONTyped(json, false);
}

export function GetLeadDiagnoses200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLeadDiagnoses200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : LeadDiagnosesFromJSON(json['data']),
    };
}

export function GetLeadDiagnoses200ResponseToJSON(json: any): GetLeadDiagnoses200Response {
    return GetLeadDiagnoses200ResponseToJSONTyped(json, false);
}

export function GetLeadDiagnoses200ResponseToJSONTyped(value?: GetLeadDiagnoses200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeadDiagnosesToJSON(value['data']),
    };
}

